import React from 'react';

import Head from 'next/head';
import sanitizeHtml from 'sanitize-html';

import {
  getBreadcrumbsListSchema,
  validateItemsForBreadcrumbsListSchema,
} from '../../helpers/schema';

interface IProps {
  items: {
    label: string;
    link?: string;
  }[];
}

export const BreadcrumbsSchema = ({ items }: IProps) => {
  if (validateItemsForBreadcrumbsListSchema(items)) {
    const breadcrumbsListSchema = getBreadcrumbsListSchema(items);
    return (
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(breadcrumbsListSchema) }}
        />
      </Head>
    );
  }

  return <></>;
};
